module.exports = __webpack_public_path__ + "img/main_logo_black.b26a4aea.svg";